import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalEventService {

  private click$ = new Subject<MouseEvent|TouchEvent>();

  private clickFocus$ = new Subject<MouseEvent|TouchEvent>();  // 메인 영역을 잘 보이도록 스크롤 시키는 기능. (현재 사용하지 않음)


  constructor() { }

  public get Click$() {
    return this.click$;
  }

  public get ClickFocus$() {
    return this.clickFocus$;
  }


  /**
   *
   * @param event
   * @param focusMain - 메인 영역을 잘 보이도록 스크롤 시키는 기능. (현재 사용하지 않음)
   * @constructor
   */
  public Click(event: MouseEvent|TouchEvent, focusMain: boolean = false) {
    this.click$.next(event);

    if (focusMain) {
      this.clickFocus$.next(event);
    }
  }
}
